<app-header [userName]="userName" (logout)="logout()" (redirectToHomePage)="redirectToHomePage()">
  <ng-container id="left-content">
    <div class="md:hidden">
      <p-button
        [text]="true"
        [icon]="menuIcon"
        (click)="onToggleSidebar()"
       />
    </div>
    <div class="hidden md:block">
      <nav class="flex" aria-label="Primary Navigation">
        @for (item of navMenuItems; track item) {
          <div class="ml-2">
            <a
              class="rounded px-4 py-2 text-neutral-700"
              [ngClass]="{ 'bg-secondary-400 text-white': item.isActive }"
              [hidden]="item.isHidden | async"
              [routerLink]="item.url"
              (click)="item.action()"
            >
              {{ item.label }}
            </a>
          </div>
        }
      </nav>
    </div>
  </ng-container>
  <ng-container *accessView="[specialtyProgramPermissions.CommunityResourcesUI]" id="right-content">
    <p-button
      severity="info"
      aria-label="Community Resources"
      type="button"
      icon="pi pi-info-circle"
      class="p-button-text community-resource-button mx-1"
      label="Community Resources"
      communityResourcesDialog
    />
  </ng-container>
</app-header>
